import { render, staticRenderFns } from "./platformPosterManage.vue?vue&type=template&id=2539408e&scoped=true"
import script from "./platformPosterManage.vue?vue&type=script&lang=ts"
export * from "./platformPosterManage.vue?vue&type=script&lang=ts"
import style0 from "./platformPosterManage.vue?vue&type=style&index=0&id=2539408e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539408e",
  null
  
)

export default component.exports